var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 299,
    viewBox: "0 0 299 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 121.126,
    height: 40.3753,
    transform: "matrix(-4.37114e-08 -1 -1 1.2114e-07 221.839 255.135)",
    fill: "#905FDD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 181.464,
    y: 134.009,
    width: 121.126,
    height: 40.3753,
    transform: "rotate(-180 181.464 134.009)",
    fill: "#FC5EC4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 76.7131,
    height: 40.3753,
    transform: "matrix(1 0 -7.74287e-08 -1 104.75 255.135)",
    fill: "#905FDD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 242.027,
    y: 77.4819,
    width: 32.3003,
    height: 32.3003,
    transform: "rotate(90 242.027 77.4819)",
    fill: "#905FDD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 66.5703,
    width: 20.1877,
    height: 20.1877,
    transform: "rotate(90 274 66.5703)",
    fill: "#905FDD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 248.574,
    y: 43,
    width: 24.2252,
    height: 24.2252,
    transform: "rotate(90 248.574 43)",
    fill: "#905FDD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 64.3754,
    y: 93.6328,
    width: 161.501,
    height: 40.3753,
    transform: "rotate(90 64.3754 93.6328)",
    fill: "#FC5EC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1bc7e67edc5dff96c228568215bdb7a0.svg";
export { ForwardRef as ReactComponent };